export default __webpack_public_path__ + "static/media/bgImage.9b960ef4.png";